import ArtImage from "./assets/art.png";
import ComputingImage from "./assets/computing.png";
import DesignTechImage from "./assets/dt.png";
import EnglishImage from "./assets/english.png";
import GeographyImage from "./assets/geography.png";
import HistoryImage from "./assets/history.png";
import LanguagesImage from "./assets/languages.png";
import MathematicsImage from "./assets/maths.png";
import MusicImage from "./assets/music.png";
import PEImage from "./assets/pe.png";
import PSHEImage from "./assets/pshe.png";
import ReligionWorldviewsImage from "./assets/re.png";
import ScienceImage from "./assets/science.png";
import SpellingImage from "./assets/spelling.png";

export const getCardDecorations = (slug: string) => {
  switch (slug) {
    case "art":
      return { accent: "var(--color-blue-500)", imageUrl: ArtImage };
    case "computing":
      return { accent: "var(--color-blue-500)", imageUrl: ComputingImage };
    case "design-tech":
      return { accent: "var(--color-blue-500)", imageUrl: DesignTechImage };
    case "english":
      return { accent: "var(--color-blue-500)", imageUrl: EnglishImage };
    case "geography":
      return { accent: "var(--color-blue-500)", imageUrl: GeographyImage };
    case "french":
      return { accent: "var(--color-blue-500)", imageUrl: LanguagesImage };
    case "history":
      return { accent: "var(--color-blue-500)", imageUrl: HistoryImage };
    case "mathematics":
      return { accent: "var(--color-blue-500)", imageUrl: MathematicsImage };
    case "music":
      return { accent: "var(--color-blue-500)", imageUrl: MusicImage };
    case "physical-education":
      return { accent: "var(--color-blue-500)", imageUrl: PEImage };
    case "pshe":
      return { accent: "var(--color-blue-500)", imageUrl: PSHEImage };
    case "religion-worldviews":
      return {
        accent: "var(--color-blue-500)",
        imageUrl: ReligionWorldviewsImage,
      };
    case "science":
      return { accent: "var(--color-blue-500)", imageUrl: ScienceImage };
    case "spanish":
      return { accent: "var(--color-blue-500)", imageUrl: LanguagesImage };
    case "spelling":
      return { accent: "var(--color-blue-500)", imageUrl: SpellingImage };
    case "handwriting":
      return { accent: "var(--color-blue-500)", imageUrl: EnglishImage };
    default:
      return { accent: "var(--color-blue-500)", imageUrl: "" };
  }
};
